var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "sidebar",
      attrs: { permanent: "", app: "", width: "260" },
      scopedSlots: _vm._u([
        {
          key: "append",
          fn: function () {
            return [
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-list",
                {
                  staticClass: "navigation-list bottom-actions",
                  attrs: { dense: "", nav: "" },
                },
                [
                  _c(
                    "v-list-item",
                    { on: { click: _vm.logout } },
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c(
                            "v-list-item-title",
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "ma-0",
                                  attrs: { align: "center", justify: "center" },
                                },
                                [
                                  _c("v-icon", { staticClass: "me-4" }, [
                                    _vm._v("mdi-logout"),
                                  ]),
                                  _vm._v(
                                    "\n              Logout\n            "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "pa-6 logo-container" }, [
        _c("img", {
          attrs: {
            src: require("@/assets/images/logo-black.svg"),
            alt: "logo",
          },
        }),
      ]),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sidebar-content" },
        [
          _c(
            "v-list",
            {
              staticClass: "navigation-list dashboard-list",
              attrs: { dense: "", nav: "" },
            },
            [
              _c(
                "v-list-item",
                { attrs: { to: "/dashboard", exact: "" } },
                [
                  _c(
                    "v-list-item-content",
                    [_c("v-list-item-title", [_vm._v("Overview")])],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "navigation-group" },
            [
              _c("div", { staticClass: "navigation-heading" }, [
                _vm._v("\n        Form Submissions\n      "),
              ]),
              _vm._v(" "),
              _c(
                "v-list",
                {
                  staticClass: "navigation-list",
                  attrs: { dense: "", nav: "" },
                },
                [
                  _c(
                    "v-list-item",
                    { attrs: { to: "/landing-contact", exact: "" } },
                    [
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Landing page")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    { attrs: { to: "/contact-us", exact: "" } },
                    [
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Contact us")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    { attrs: { to: "/investment-contact", exact: "" } },
                    [
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Investment")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    { attrs: { to: "/product-contact", exact: "" } },
                    [
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Products")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    { attrs: { to: "/software-contact", exact: "" } },
                    [
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Software")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    { attrs: { to: "/service-contact", exact: "" } },
                    [
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Services")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    { attrs: { to: "/registration-mails", exact: "" } },
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v("Registration Mails"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "navigation-group" },
            [
              _c("div", { staticClass: "navigation-heading" }, [
                _vm._v("\n        Recruiting\n      "),
              ]),
              _vm._v(" "),
              _c(
                "v-list",
                {
                  staticClass: "navigation-list",
                  attrs: { dense: "", nav: "", exact: "" },
                },
                [
                  _c(
                    "v-list-item",
                    { attrs: { to: "/careers" } },
                    [
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Job openings")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    { attrs: { to: "/job-applications", exact: "" } },
                    [
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Applications")])],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "navigation-group" },
            [
              _c("div", { staticClass: "navigation-heading" }, [
                _vm._v("\n        Content\n      "),
              ]),
              _vm._v(" "),
              _c(
                "v-list",
                {
                  staticClass: "navigation-list",
                  attrs: { dense: "", nav: "" },
                },
                [
                  _c(
                    "v-list-item",
                    { attrs: { to: "/articles", exact: "" } },
                    [
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Articles")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    { attrs: { to: "/news", exact: "" } },
                    [
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("News")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item",
                    { attrs: { to: "/products", exact: "" } },
                    [
                      _c(
                        "v-list-item-content",
                        [_c("v-list-item-title", [_vm._v("Products")])],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isAdmin
            ? _c(
                "div",
                { staticClass: "navigation-group" },
                [
                  _c("div", { staticClass: "navigation-heading" }, [
                    _vm._v("\n        Administration\n      "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    {
                      staticClass: "navigation-list",
                      attrs: { dense: "", nav: "" },
                    },
                    [
                      _c(
                        "v-list-item",
                        { attrs: { to: "/user-management", exact: "" } },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v("User Management"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }